import {
  getInjectionSites,
  removeInjectionSite,
  setInjectionSiteFilters,
  updateInjectionSite,
} from '@state/reducers/injectionSiteReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { InjectionSiteDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import InjectionSiteForm from '../forms/InjectionSiteForm'
import { SideLabels } from '@utils/constants'

export default function InjectionSitesTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setInjectionSiteFilters({ includeInactive: false }))
    }
  }, [])
    
  const columns: GridColumns<InjectionSiteDto> = useMemo(
    () => [
      { field: 'code', headerName: 'Code', width: 150 },
      { field: 'bodyPart', headerName: 'Partie du corps', width: 200 },
      { field: 'side', headerName: 'Côté', width: 100, valueGetter: ({ value }) => SideLabels[value] || '' },
    ],
    [],
  )

  return (
    <BaseConfigTable<InjectionSiteDto>
      columns={columns}
      selectRows={(state) => state.injectionSite.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setInjectionSiteFilters({ includeInactive: true }))
        return dispatch(getInjectionSites())
      }}
      deleteThunk={removeInjectionSite}
      toggleThunk={(id, isActive) => updateInjectionSite({ id, dto: { isActive } })}
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setInjectionSiteFilters({ page }))
        dispatch(getInjectionSites())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <InjectionSiteForm 
          editingInjectionSite={editingItem} 
          onClose={onClose} 
        />
      )}
      resourceLabel="site d'injection"
      resourcePrefix="le "
    />
  )
}
